(function () {
  'use strict';

  angular
    .module('gazingpensive', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'ngMaterial',
      'toastr',
      'firebase'
    ]);

})();

(function() {
  'use strict';

  angular
      .module('gazingpensive')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment, $state) {
      var vm = this;
      vm.go = go;
      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();

      function go(location) {
        console.log(location);
        $state.go(location);
      }
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('gazingpensive')
        .controller('WelcomeController', WelcomeController);

    /** @ngInject */
    function WelcomeController($state) {
        var vm = this;
        vm.enter = enter;

        function enter() {
            $state.go('profiles');
        }

    }

} ());
(function() {
    'use strict';

    angular
        .module('gazingpensive')
        .service('utilityService', utilityService);

    /** @ngInject */
    function utilityService() {

        return {
            shuffleArray: shuffleArray
        }

        function shuffleArray(array) {
            var currentIndex = array.length,
                temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        }

    }

}());
(function() {
    'use strict';

    angular
        .module('gazingpensive')
        .service('userService', userService);

    /** @ngInject */
    function userService($scope, $firebaseAuth, $log) {

        var auth = $firebaseAuth();

        return {
            signIn: signIn,
            createUser: createUser,
            signOut: signOut
        };

        function signIn(email, password) {
            return auth.$signInWithEmailAndPassword(email, password).then(function(firebaseUser) {
                $log.log("Signed in as:", firebaseUser.uid);
            }).catch(function(error) {
                $log.error("Authentication failed:", error);
            });
        }

        function createUser(email, password){
            var userRef = firebase.database().ref().child('users')

            return auth.$createUserWithEmailAndPassword(email, password)
                .then(function(firebaseUser) {
                    $log.log("User " + firebaseUser.uid + " created successfully!");
                    userRef.push().set(firebaseUser.uid)
                }).catch(function(error) {
                    $log.error("Error: ", error);
                });
        }

        function signOut(){
            auth.$signOut()
        }
    }
}());
(function () {
  'use strict';
  angular.module('gazingpensive')

    .factory('refService', refService);

  /** @ngInject **/
  function refService(firebase) {

    var ref = firebase.database().ref();
    var usersRef = ref.child('users');

    var refPath = {
      ref: ref,
      usersRef: usersRef
    };

    return refPath;
  }

})();

(function(){
    'use strict';

    angular
        .module('gazingpensive')
        .filter('lineBreak', lineBreak);

    function lineBreak(){

        return FilterFn;

        function FilterFn(params){
            
            return params.replace(/ \\/g, ', ');
        }
    }

}());
(function () {
    'use strict';

    angular
        .module('gazingpensive')
        .service('dataService', dataService);

    /** @ngInject */
    function dataService($firebaseArray, refService) {

        return {
            getQuotes: getQuotes,
            getUsers: getUsers
        }

        function getQuotes(category) {
            var quotesRef = firebase.database().ref().child('quotes').child(category);
            return $firebaseArray(quotesRef).$loaded();
        }

        function getUsers() {
            var usersRef = refService.usersRef;
            return $firebaseArray(usersRef).$loaded();
        }

    }

} ());
(function () {
    'use strict';
    angular.module('gazingpensive')

        .factory('authService', authService);

    /** @ngInject **/
    function authService($log, $firebaseAuth, $state, moment, $q) {

        var ref = firebase.database().ref();
        var authSession = $firebaseAuth();
        var storageRef = firebase.storage().ref();
        var defaultPhotoURL = "https://firebasestorage.googleapis.com/v0/b/labeinstein.appspot.com/o/images%2Feinstein.png?alt=media&token=970b846b-ed63-48a1-999b-7a4e944d38d9";

        var service = {
            checkAuthSession: checkAuthSession,
            signIn: signIn,
            signOut: signOut,
            createUser: createUser,
            currentUser: currentUser,
            uploadImage: uploadImage
        };

        return service;

        function checkAuthSession() {
            return authSession.$requireSignIn();
        }

        function signIn(email, password) {
            authSession.$signInWithEmailAndPassword(email, password)
                .then(function (auth) {
                    $log.debug("User " + auth.uid + " signin successfully!");
                }).catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    $log.debug(errorCode, errorMessage);
                    // ...
                });
        }

        function signOut() {
            authSession.$signOut();
        }

        function createUser(user) {
            return authSession.$createUserWithEmailAndPassword(user.email, user.password)
                .then(function (firebaseUser) {
                    signIn(user.email, user.password);
                    delete user.password; // dont save users secrets
                    user.dateRegistered = moment.utc().valueOf();
                    ref.child('users').child(firebaseUser.uid).set(user);
                    $log.debug("User " + firebaseUser.uid + " created successfully!");
                    return firebaseUser.uid;
                    // $state.go('admin');
                }).catch(function (error) {
                    if (error) {
                        switch (error.code) {
                            case "auth/email-already-in-use":
                                $log.debug("Error email in use:", error);
                                break;
                            case "auth/invalid-email":
                                $log.debug("Error invalid email:", error);
                                break;
                            default:
                                $log.debug("Error creating user:", error);
                        }
                    }
                });
        }

        function currentUser() {
            var deferred = $q.defer();
            var user = firebase.auth().currentUser;
            if (user != null) {
                // get the date of registeration
                ref.child('users').child(user.uid).once('value').then(function (snapshot) {
                    var userInfo = {
                        name: user.displayName || user.email.split("@")[0],
                        email: user.email,
                        photoUrl: user.photoURL || defaultPhotoURL,
                        created: moment(snapshot.dateRegistered).format("YYYY MMMM")
                    };
                    deferred.resolve(userInfo);
                });
            }
            return deferred.promise;
        }

        function updateUserProfileImage(url) {
            var user = firebase.auth().currentUser;
            user.updateProfile({
                photoURL: url
            }).then(function () {
                $log.debug("Profile updated with image: ", url);
            }, function (error) {
                $log.debug(error);
            });
        }

        function uploadImage(file, userId) {
            var deferred = $q.defer();
            var uploadTask = storageRef.child('images/' + file.name).put(file);
            uploadTask.on('state_changed', function (snapshot) {
                // Observe state change events such as progress, pause, and resume
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                $log.debug('Upload is ' + progress + '% done');
            }, function (error) {
                // Handle unsuccessful uploads
                deferred.reject(error);
                $log.debug(error);
            }, function () {
                // Handle successful uploads on complete
                var downloadURL = uploadTask.snapshot.downloadURL;
                setUserImage(downloadURL,userId);
                deferred.resolve(downloadURL);
            });
            return deferred.promise;
        }

        function setUserImage(url,userId) {
            console.log("USERID:", userId);
            ref.child('users').child(userId).child('photoURL').set(url);
            ref.child('images').child(userId).set({
                photoURL: url,
                createdAt: moment.utc().valueOf()
            });
        }


    }

})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController($state, authService, $q, $log, toastr, usersData, utilityService, quotesData) {

    var vm = this;
    vm.requote = requote;
    vm.quotesData = utilityService.shuffleArray(quotesData);
    
    vm.users = usersData;

    function requote(){
      vm.quotesData = utilityService.shuffleArray(quotesData);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, authService, $q, $log, toastr) {

    var vm = this;

    vm.newUser = true;
    vm.signIn = signIn;
    vm.createUser = createUser;
    vm.goSign = goSign;
    vm.backLogin = backLogin;

    vm.user = {};

    function signIn(formInvalid) {
      if (!formInvalid) {
        authService.signIn(vm.user.email, vm.user.password);
      }
    }

    function createUser(formInvalid) {
      if (!formInvalid) {
        authService.createUser(vm.user)
          .then((function (firebaseId) {
            $log.log("FIREBASEID: ", firebaseId);
            $log.log("VM.USER: ", vm.user);
            authService.uploadImage(vm.userImage, firebaseId);
            toastr.success("Successfully created account");
            $state.go('profiles');
          }));
      }
    }

    function goSign() {
      $state.go('profiles');
    }

    function backLogin() {
      $state.go('profiles');
    }

  }
})();
(function () {
    'use strict';
    angular
        .module('gazingpensive')
        .directive('fileUploader', function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var model = $parse(attrs.fileUploader);
                    var modelSetter = model.assign;
                    element.bind('change', function () {
                        scope.$apply(function () {
                            modelSetter(scope, element[0].files[0]);
                            element.focus();
                        });
                    });
                }
            };
        });
})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .controller('AccountController', AccountController);

  /** @ngInject */
  function AccountController(profile, authService, notifyService, authData) {
    var vm = this;
    vm.profile = profile;
    vm.passwordChange = passwordChange;
    vm.uploadImage = uploadImage;

    function passwordChange(formInvalid) {
      if (formInvalid) {
        if (vm.password.older && vm.password.confirm) {
          notifyService.displayToast("Passwords Pattern Invalid!");
        } else {
          notifyService.displayToast("Please Complete all fields");
        }
      } else {
        if (vm.password.new !== vm.password.confirm) {
          notifyService.displayToast("Passwords do not match!");
        } else {
          authService.passwordChange(vm.profile.email, vm.password);
          vm.password = '';
        }
      }
    }

    function uploadImage() {
      authService.uploadImage(authData.uid, vm.userImage);
      angular.element('#image-file').val(null);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController(quotesData, utilityService) {
    var vm = this;

    vm.quoteData = utilityService.shuffleArray(quotesData);
    vm.counter = 1;

  }
})();

(function() {
  'use strict';

  angular
    .module('gazingpensive')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('welcome', {
        url: '/',
        views: {
          '@': {
            templateUrl: 'app/welcome/welcome.html',
            controller: 'WelcomeController',
            controllerAs: 'vm'
          }
        },
        resolve: {
        }
      })
      .state('profiles', {
        url: '/main',
        views: {
          '@': {
            templateUrl: 'app/profiles/profiles.html',
            controller: 'ProfileController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          'usersData': ['dataService', function (dataService) {
            return dataService.getUsers();
          }],
          'quotesData': ['dataService', function (dataService) {
            return dataService.getQuotes('art');
          }]
        }
      })
      .state('about', {
        url: '/about',
        views: {
          '@': {
            templateUrl: 'app/about/about.html',
            controller: 'AboutController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          'quotesData': ['dataService', function (dataService) {
            return dataService.getQuotes('beauty');
          }]
          // 'authSession': ['authService', function (authService) {
          //   return authService.checkAuthSession();
          // }]
        }
      })
      .state('login', {
        url: '/login',
        views: {
          '@': {
            templateUrl: 'app/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        }
      })
    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('gazingpensive')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function () {
  'use strict';

  angular
    .module('gazingpensive')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $mdThemingProvider, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    $locationProvider.html5Mode(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $mdThemingProvider.theme('default')
      .primaryPalette('blue-grey')
      .accentPalette('green');

    var config = {
      apiKey: "AIzaSyDj1XgW4gD1XfM_JNkGiM7u8MNVnNUv4I8",
      authDomain: "gazingpensive.firebaseapp.com",
      databaseURL: "https://gazingpensive.firebaseio.com",
      storageBucket: "gazingpensive.appspot.com",
      messagingSenderId: "126461700644"
    };

    firebase.initializeApp(config);

  }

})();

angular.module("gazingpensive").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<header><navbar></navbar></header><div class=container layout=column layout-align=\"center center\"><img src=/assets/images/gazing_pensively.png alt=\"gazing pensive\" class=picture><div class=quote ng-if=vm.quoteData>\"{{vm.quoteData[vm.counter].text | lineBreak}}\"</div><md-button class=\"md-accent md-raised\" ng-click=\"vm.counter=+vm.counter + 1\">Tell me more, Jeff</md-button></div><div class=site-description layout=column layout-align=\"center center\"><div><h1>Looking Thoughtful, Feeling Thoughtful</h1><h3>Mindful? Hopeful? Wistful?</h3>Gaze pensively with me for a moment as we consider big life questions.<ul><li>What if the air is poisonous, and it just takes 80 years to kill us?</li><li>What are snails even trying to do?</li><li>What if \"Soy Milk\" is just Regular Milk introducing himself in Spanish?</li></ul>Big questions need big answers. Let\'s stare off into the distance and ponder life\'s mysteries together.<br><br>- Jeff</div></div><footer><hr><div layout=row layout-align=\"center center\">Creating Lovingly by Pensive Gazers Everywhere</div></footer>");
$templateCache.put("app/account/account.html","<div class=account><div class=row><div class=\"col s10 m6 offset-m3 offset-s1\"><div class=\"card account-card\"><div class=card-title>Account Information</div><div class=card-content><div class=user-content><div class=user-info><p>Name: {{vm.profile.name}}</p><p>Email: {{vm.profile.email}}</p></div><div class=user-image ng-if=vm.profile.photoURL><img base64-src=vm.profile.photoURL></div></div><div><form class=file-form><div class=file-input><div><label>Upload Avatar Image</label></div><input type=file id=image-file placeholder=\"upload image\" file-uploader=vm.userImage></div><button type=submit class=\"btn submit-btn\" ng-click=vm.uploadImage()>Upload Image</button></form></div></div></div></div></div><div class=row><div class=\"col s10 m6 offset-m3 offset-s1\"><div class=\"card account-card\"><div class=card-title>Change Password</div><form name=accountForm><div class=form-group><input type=password placeholder=\"Enter Current Password\" class=validate ng-model=vm.password.older required></div><div class=form-group><input type=password placeholder=\"Enter New Password\" class=validate ng-model=vm.password.new name=resetPassword ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/\" ng-focus=\"showPasswordLabel=true\" ng-blur=\"showPasswordLabel=false\" required><label for=password ng-show=\"accountForm.resetPassword.$invalid && showPasswordLabel\">At least 7 characters with one uppercase character and one number</label></div><div class=form-group><input type=password placeholder=\"Confirm New Password\" class=validate ng-model=vm.password.confirm required></div><button type=submit class=\"btn submit-btn\" ng-click=vm.passwordChange(accountForm.$invalid);>Change Password</button></form></div></div></div></div>");
$templateCache.put("app/login/login.html","<header><navbar></navbar></header><md-card flex-offset=25 flex=50 layout=column class=md-inline-form><div ng-show=vm.newUser><md-card-title><md-card-title-text>Create a Pensive Account</md-card-title-text></md-card-title><md-card-content><form ng-submit=vm.createUser(loginForm.$invalid) name=loginForm><md-input-container layout><label>Name</label><input ng-model=vm.user.name type=text name=userText required></md-input-container><md-input-container layout><label>E-mail</label><input ng-model=vm.user.email type=email name=userEmail required></md-input-container><md-input-container layout><label>Password</label><input ng-model=vm.user.password type=password name=userPassword minlength=6 maxlength=100 ng-pattern=\"/^(?=.*?[a-z])(?=.*?[0-9]).{6,}$/ \" ng-focus=\"showPasswordError=true\" ng-blur=\"showPasswordError=false\" required><div ng-messages=\"signForm.userPassword.$error \" role=\"alert \"><div ng-if=showPasswordError><div ng-message-exp=\"[ \'required\', \'minlength\', \'maxlength\', \'pattern\'] \">Password should be at least six characters with one number.</div></div></div></md-input-container><md-input-container><label>Upload Image</label><input type=file id=image-file placeholder=\"Upload Image\" file-uploader=vm.userImage required></md-input-container><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=submit>Create User</md-button><md-button class=md-raised ng-click=\"vm.newUser = !vm.newUser\">I already have an account</md-button></md-card-actions></form></md-card-content></div><div ng-hide=vm.newUser><md-card-title><md-card-title-text>Login in Form</md-card-title-text></md-card-title><md-card-content><form ng-submit=vm.signIn(signForm.$invalid) name=signForm><md-input-container><label>E-mail</label><input ng-model=vm.user.email type=\"email \" name=\"userEmail \" required></md-input-container><md-input-container><label>Password</label><input ng-model=vm.user.password type=password name=userPassword required></md-input-container><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=submit>Sign In</md-button><md-button class=md-raised ng-click=\"vm.newUser = !vm.newUser\">I need an account</md-button></md-card-actions></form></md-card-content></div></md-card>");
$templateCache.put("app/login/signin.html","<div layout=row layout-align=\"center center\" class=auth-sign><div flex=45 flex-sm=90><div class=sign-logo><img src=/assets/images/EinsteinLogin.png><p>Let\'s be friends, create an account with me!</p></div><div class=form-content><form name=signForm><md-input-container><label>E-mail</label><input ng-model=vm.email type=email name=userEmail required></md-input-container><md-input-container><label>Password</label><input ng-model=vm.password type=password name=userPassword minlength=10 maxlength=100 ng-pattern=\"/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/\" ng-focus=\"showPasswordError=true\" ng-blur=\"showPasswordError=false\" required><div ng-messages=signForm.userPassword.$error role=alert><div ng-if=showPasswordError><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Password should be at least seven characters with one uppercase character and one number.</div></div></div></md-input-container><md-button class=\"md-raised md-primary\" ng-click=vm.createUser(signForm.$invalid);>Create</md-button><div class=back-login ng-click=vm.backLogin();><span>Already have an Account</span></div></form></div></div></div>");
$templateCache.put("app/profiles/profiles.html","<header><navbar></navbar></header><div class=content><md-content flex-xs=100 flex=20 layout=row><div flex layout=column><md-card ng-repeat=\"user in vm.users track by $index\"><img ng-src={{user.photoURL}} class=md-card-image style=height:80% alt=\"gazing pensive\"><mv-card-title><md-card-title-text><span class=md-headline>{{user.name}}</span></md-card-title-text></mv-card-title><md-card-content class=md-padding>{{vm.quotesData[$index].text}}</md-card-content><md-button class=md-icon-button aria-label=Favorite><md-icon md-svg-icon=assets/icons/favorite.svg></md-icon></md-button></md-card></div></md-content></div><!--\n<div class=\"md-primary\">\n	<div ng-repeat=\"user in vm.users\">\n		<img ng-src=\"{{user.photoURL}}\"></img>\n	</div>-->");
$templateCache.put("app/welcome/welcome.html","<header><navbar></navbar></header><md-content><img src=/assets/images/ocean_gaze.jpeg alt=\"gazing pensive\" class=image></md-content><div layout=row layout-xs=column><div flex=20 hide-xs></div><div flex=20 flex-xs=100 layout-align-xs=\"center center\"><img src=/assets/images/jeff.jpg alt=jeff class=portrait></div><div flex=40 flex-xs=100><div layout=column><div class=welcome-msg><h1 class=welcome-title>My name is Jeff</h1><div><h3>And I\'m disheartened by the current state of the internet.</h3><div>Social media is littered joyous faces, plastic smiles, and fairy tales lives...<br \\><br \\>But where do I go to find other thoughtful, stoics?<br \\>How do I find those pondering life\'s big mysteries?<br \\>Who else shares in my dream of dreaming?<br \\></div><h3>Do you share my vision of staring into the sunset and gazing pensively?</h3></div><div layout=row layout-align=\"center center\"><md-button class=\"md-primary md-raised welcome-btn\" ng-click=vm.enter();>Join me on this thoughtful journey</md-button></div></div></div><div flex=20></div></div></div><footer><hr><div layout=row layout-align=\"center center\">Creating Lovingly by Pensive Gazers Everywhere</div></footer>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row class=navbar><md-button flex=10 flex-xs=50 href=/ aria-label=\"Gazing Pensive Club\">Gazing Pensive</md-button><md-menu flex flex-xs=50><md-button md-menu-origin ng-click=$mdOpenMenu()>Options</md-button><md-menu-content width=2><md-menu-item><md-button ng-click=\"vm.go(\'login\');\">Create</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.go(\'about\');\">About</md-button></md-menu-item></md-menu-content></md-menu></md-toolbar>");}]);